import { createContext } from 'react';
import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';
import { getDefaultTheme } from 'utils/environmentVariables';

export const SgBsThemeContext = createContext<SgBsTheme>(getDefaultTheme());
SgBsThemeContext.displayName = 'SgBsThemeContext';
